import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotEvents from './components/HotEvents';
import LatestNews from './components/LatestNews';
import PromotionsSection from './components/PromotionsSection';
import FAQSection from './components/FAQSection';

const organizationSchema = {
  name: 'bb体育',
  url: 'https://www.bbsports.com',
  description: 'bb体育是值得信赖的体育竞技娱乐平台，提供丰富的体育赛事投注、实时赛况直播、专业数据分析等服务。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'service@bbsports.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  name: 'bb体育 - 官方体育竞技平台',
  url: 'https://www.bbsports.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.bbsports.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqPageSchema = {
  mainEntity: [
    {
      '@type': 'Question',
      name: 'bb体育平台是否安全可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育平台持有合法运营牌照，采用国际领先的加密技术保护用户数据和资金安全。平台运营多年，已为数百万用户提供稳定可靠的服务。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在bb体育注册账号？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '注册bb体育账号非常简单，只需点击页面右上角的"注册"按钮，填写基本信息并完成手机号或邮箱验证，即可在3分钟内完成注册。',
      },
    },
    {
      '@type': 'Question',
      name: 'bb体育支持哪些体育赛事？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育覆盖全球超过30个体育项目的赛事，包括足球、篮球、网球、棒球、冰球、排球、乒乓球、羽毛球、电竞等。',
      },
    },
    {
      '@type': 'Question',
      name: '如何查看实时比分和赛事直播？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '登录bb体育平台后，在"赛事直播"板块即可查看所有正在进行和即将开始的赛事。我们提供实时比分更新、文字直播和部分赛事的视频直播服务。',
      },
    },
    {
      '@type': 'Question',
      name: '平台支持哪些充值方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育支持多种安全便捷的充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等。充值实时到账，无手续费。',
      },
    },
    {
      '@type': 'Question',
      name: '提现需要多长时间？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育提供快速提现服务，大多数提现申请在30分钟内处理完毕。首次提现需要进行身份验证以确保资金安全。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="FAQPage" data={faqPageSchema} />

      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />
        <CategoryNav />
        <HotEvents />
        <LatestNews />
        <PromotionsSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}